import styles from "./googlemaps-styles";
import loadGoogleMapsApi from 'load-google-maps-api';
const googleMapsApiKey = 'AIzaSyAI1wIyv-frm9-zAzBplTm0UGhXjq9P0Ic'


class Map { 

    static loadApi() {
      return loadGoogleMapsApi({ key: googleMapsApiKey });
    }
   
}


export default () => {
    
    let mapElements = document.querySelectorAll('.b-maps-map');

    if(!mapElements) 
        return


    mapElements.forEach(mapElement => {

        let settings = {
            lat: parseFloat(mapElement.getAttribute('data-lat')),
            lng: parseFloat(mapElement.getAttribute('data-lng')),
            zoom: parseInt(mapElement.getAttribute('data-zoom')),       
            style: styles.mapStyle
        }

    
        Map.loadApi().then(function(googleMaps) {
            
            let map = new googleMaps.Map(mapElement, {
                center: { 
                    lat: settings.lat, 
                    lng: settings.lng 
                },            
                zoom: settings.zoom,
                styles: settings.style,
                draggable: true, 
                scrollwheel: true, 
                disableDoubleClickZoom: false,
                disableDefaultUI: true,


            })

            //map.setOptions({});


            

            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(settings.lat, settings.lng),
                map: map,
                icon: window.location.origin + '/app/themes/joma/assets/img/map-marker.png' // null = default icon

            });
            
        })
    
    });

}